import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { INoteEntity } from '../../shared';
import { CreateNoteDto } from '../../dtos/note.dto';

export class NoteService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<INoteEntity>(path, search, 'notes');
  }

  public async create(
    path: string,
    args: ConstructorParameters<typeof CreateNoteDto>[number],
  ) {
    return await this.post<void, CreateNoteDto>(
      path,
      new CreateNoteDto(args),
      'Create claim note',
    );
  }
}
